/**
 * DELETE ARTICLE
 */
export const ADMIN_ARTICLE_AUTHOR_DELETE = "admin/ADMIN_ARTICLE_AUTHOR_DELETE";
export const ADMIN_ARTICLE_AUTHOR_DELETE_SUCCESS = "admin/ADMIN_ARTICLE_AUTHOR_DELETE_SUCCESS";
export const ADMIN_ARTICLE_AUTHOR_DELETE_FAILURE = "admin/ADMIN_ARTICLE_AUTHOR_DELETE_FAILURE";
